<template>
    <div>
        <BModal id="modal-1" v-model="visible" hideFooter hideHeader noCloseOnBackdrop noCloseOnEsc centered >
            <div class="text-center p-2 align-middle"><MentionLogoLoader :label="text" /></div>
        </BModal>
    </div>
</template>

<script>
  import store from "@/state/store";
  import MentionLogoLoader from "@/components/loadings/mention-logo-loader.vue";
  export default {
    name: 'WaitModal',
    components: {
      MentionLogoLoader
    },
    computed: {
      visible() {
        return store.getters['notification/modalWaitVisible']
      },
      text() {
        return store.getters['notification/modalWaitText']
      }
    }
  };
</script>
  